import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { AuthenticationService } from './auth.service';
import { CommonService } from './../../../service/common.service';
import { Injectable } from '@angular/core';
import { MatCarouselSlideComponent } from '@ngmodule/material-carousel';
import { MenuService } from '@core/services/menu.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { locale } from 'moment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { PrivacyPolicyPopupComponent } from '../privacy-policy-popup/privacy-policy-popup.component';
import { PrivacyPolicyDTO } from 'app/model/privacy-policy.enum';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  items = [
    { title: 'Centralized Audit Management System', desc: ' ' },
    { title: 'Centralized Audit Management System', desc: ' ' },
  ];

  username: string;
  password: string;
  userTeamType: string;
  defaultHomeScreenId: string;
  defaultHomeScreenUrl: string;
  public parentHeight = '100vh';
  public timings = '250ms ease-in';
  public autoplay = true;
  public interval = 5000;
  public loop = true;
  public hideArrows = false;
  public hideIndicators = false;
  public maxWidth = 'auto';
  public maintainAspectRatio = true;
  public proportion = 25;
  public slideHeight = '100vh';
  public hideOverlay = true;
  public useKeyboard = true;
  public useMouseWheel = false;
  public log: string[] = [];
  successMessage: string;
  errorMessage: string;
  invalidLogin = false;
  loginSuccess = false;
  // url = environment.SERVER_URL;
  privacyPolicyDTO: PrivacyPolicyDTO = new PrivacyPolicyDTO();

  @ViewChildren(MatCarouselSlideComponent) public carouselSlides: QueryList<
    MatCarouselSlideComponent
  >;

  reactiveForm: FormGroup;
  parsedJson: any;

  constructor(
    private modeldialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private menuService: MenuService,
    private http: HttpClient,
    private commonService: CommonService
  ) {
    this.reactiveForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    //This is first commmit
    //This is my second comment
  }

  login() {
    this.username = this.reactiveForm.get('username').value;
    //encryptPassword function added on 08-09-2021 for encrypt password.
    this.password = this.encryptPassword(this.reactiveForm.get('password').value);
    this.authenticationService.authenticationService(this.username, this.password).subscribe(
      result => {
        this.invalidLogin = false;
        this.loginSuccess = true;
        var clientList = JSON.parse(localStorage.getItem('clientList'));
        this.privacyPolicyDTO.userId = clientList[0].userDetails.userId;
        this.authenticationService.checkforprivacyPolicy(this.privacyPolicyDTO).subscribe(
          data => {
            this.parsedJson = JSON.parse(JSON.stringify(data));
            if (this.parsedJson.isAccepted == '0') {
              const dialogRef = this.modeldialog.open(PrivacyPolicyPopupComponent, {
                disableClose: false,
                width: '100vw',
                height: '100vh',
                maxWidth: '100vw',
                maxHeight: '100vh',
                data: clientList,
              });

              dialogRef.afterClosed().subscribe((result: boolean) => {
                if (result == true) {
                  this.userTeamType = localStorage.getItem('userTeamType');

                  //Added on 13-Dec-2024 -- start
                  this.defaultHomeScreenId = localStorage.getItem('defaultHomeScreenId');
                  this.defaultHomeScreenUrl = localStorage.getItem('defaultHomeScreenUrl');
                  this.router.navigate(['/']);

                  if (this.defaultHomeScreenId != null) {
                    this.router.navigate([this.defaultHomeScreenUrl]);
                  }
                  //Added on 13-Dec-2024 -- start
                  else if (this.userTeamType == 'Auditee Area')
                    this.router.navigate(['/auditeehome/auditeehome']);
                  else this.router.navigate(['/auditorhome/auditorhome']);
                } else {
                  dialogRef.close();
                  localStorage.clear();
                }
              });
            } else {
              this.userTeamType = localStorage.getItem('userTeamType');
              this.defaultHomeScreenId = localStorage.getItem('defaultHomeScreenId');
              this.defaultHomeScreenUrl = localStorage.getItem('defaultHomeScreenUrl');
              this.router.navigate(['/']);

              if (this.defaultHomeScreenId != null) {
                this.router.navigate([this.defaultHomeScreenUrl]);
              } else if (this.userTeamType == 'Auditee Area')
                this.router.navigate(['/auditeehome/auditeehome']);
              else this.router.navigate(['/auditorhome/auditorhome']);
            }
          },
          error => {
            // this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
          }
        );
      },
      err => {
        this.invalidLogin = true;
        this.loginSuccess = false;
        this.errorMessage = err;
      }
    );
  }

  openprivacydialog(clientList) {
    const dialogRef = this.modeldialog.open(PrivacyPolicyPopupComponent, {
      disableClose: false,
      data: clientList,
    });

    dialogRef.afterClosed().subscribe(result => {});
    return dialogRef;
  }

  //Function used to encrypt password. 08-09-2021
  encryptPassword(oldPassword: string) {
    var length = oldPassword.length;
    var newPassword: string = '';
    var temp: number[] = new Array(length);
    var i: number = 0;
    var ran: number = Math.floor(Math.random() * 256) + 1;
    var ch;

    for (i = 0; i < length; i++) {
      ch = oldPassword.charCodeAt(i); //charAt(i);
      temp[i] = parseInt('' + ch);

      if (temp[i] >= 0 && temp[i] < 64) temp[i] += 128;
      else if (temp[i] >= 64 && temp[i] < 128) temp[i] += 128;
      else if (temp[i] >= 128 && temp[i] < 192) temp[i] -= 128;
      else if (temp[i] >= 192 && temp[i] < 256) temp[i] -= 128;
      temp[i] += ran;
      newPassword += this.convertToBoolean(temp[i]);
    }
    newPassword += this.convertToBoolean(ran);
    return newPassword;
  }
  //End

  //Function to convert number in binary format.
  convertToBoolean(intcode: number) {
    var num: number = intcode;
    var quot;
    var div: number = 2;
    var rem;
    var temp: number[] = new Array(9);
    var temp2: number[] = new Array(9);
    var len: number = temp.length;
    var str: string = '';
    var k: number = 0;
    for (k = 0; num != 0; k++) {
      quot = num / div;
      quot = parseInt(quot);
      rem = num % div;
      rem = parseInt(rem);
      temp[k] = rem;
      num = quot;
    }

    for (let i = k; i < len; i++) temp[i] = 0;

    for (let i = len - 1, j = 0; i >= 0; i--, j++) {
      temp2[j] = temp[i];
    }

    for (let i = 0; i < len; i++) str += temp2[i];
    return str;
  }
  //End
}
